<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: BCC Pubs
      Author: SweetAs
    Author URL: http://sweetas.xyz
========================================================================================== -->
<template>
  <div class="mt-3">
    <div class="vx-row mb-6">
      <div class="vx-col w-full">  
        <vx-card>
          <div class="mt-3">
            <vs-table
              stripe 
              pagination
              :max-items="pagPageSize"   
              :data="ipsites"
              search
              @selected="getIpSiteDetails">
                <template slot="header">
                   <vs-button color="success" type="filled" icon-pack="feather" 
                   icon="icon-plus" @click="newIpSite" style="float:right;" >New</vs-button>
                </template>
                <template slot="thead">
                  <vs-th sort-key="refid">Infopoint</vs-th>
                  <vs-th sort-key="company">Company</vs-th>
                  <vs-th sort-key="address1">Address 1</vs-th>
                  <vs-th sort-key="postcode">Postcode</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr  :data="tr" :key="i" v-for="(tr, i) in data">
                    <vs-td :data="data[i].refid">
                    {{ data[i].refid }}
                    </vs-td>
                    <vs-td :data="data[i].company">
                    {{ data[i].company }}
                    </vs-td>
                    <vs-td :data="data[i].address1">
                    {{ data[i].address1 }}
                    </vs-td>
                    <vs-td :data="data[i].postcode">
                    {{ data[i].postcode }}
                    </vs-td>
                </vs-tr>
              </template>              
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div> 
    <vs-popup
      title="Infopoint Site"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt ">
        <vs-alert :active.sync="changesDetected"  color="danger" class="text-center">
           <span>Warning: Details have changed, please save Details before exiting.</span>
        </vs-alert>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vx-card title="Address">
              <div>              
                <vs-alert :active.sync="sw_isNewError" color="danger" class="text-center">
                  <span>Warning: Infopoint Id already in use.</span>
                </vs-alert>

                <div class="vx-row mb-6 mt-5">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Infopoint Id" v-model="sw_id" :disabled="!sw_isNew"  />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Company Name" v-model="sw_company"  />
                  </div>
                </div>
                <v-select :filterable="false" :options="sw_options" label="Id" :clearable="true"
                 @search="onSearch" v-model="sw_select" :components="{Deselect}">
                  <template slot="no-options">
                   {{ search_text }}
                  </template>
                  <template slot="option" slot-scope="option" :label="option.Id">
                    <div class="d-center">
                      {{ option.Text }} <small> {{ option.Description }} </small>
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.text }}
                    </div>
                  </template>
                </v-select>
                <div class="vx-row mt-2 mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 1" v-model="sw_address1" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 2" v-model="sw_address2" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 3"  v-model="sw_address3" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Town" v-model="sw_town" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Country" v-model="sw_country" />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Postcode" v-model="sw_postcode" />
                  </div>
                </div>
              </div>
            </vx-card>
            <div class="vx-row" vs-align="center"  vs-type="flex" vs-justify="space-around" vs-w="12">
              <div class="vx-col w-1/2 mt-5">
                <vs-button v-if="!sw_isNew" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" @click="deleteIp" >Delete</vs-button>
              </div>
              <div class="vx-col w-1/2 mt-5">
                <vs-button 
                v-if='!sw_isNewError'
                color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="updateAdd" style="float:right;" >{{isUpdateOrNew}}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup> 
  </div>
</template>
<script>
import vSelect from 'vue-select'
export default{
  components: { 
     'v-select': vSelect,
  },
  data () {
    return { 
      ipsites:[],  
      pagPages:0,
      pagPageSize: 8,
      pagCurrentX: 1,
      activePrompt:false,
      changesDetected:false,    
      key:'MR34-BM33-RH83-EA34',   
      sw_isNew:false,
      sw_isNewError:false,
      sw_address1:'',
      sw_address2:'',
      sw_address3:'',
      sw_town:'',
      sw_country:'',
      sw_postcode:'',
      sw_addresses:[],
      sw_options:[],
      sw_select:[],
      sw_id: '',    
      sw_title: '',
      sw_firstname: '',
      sw_surname: '',
      sw_email: '',
      sw_telephone: '',
      sw_mobile: '',
      sw_password: '',
      sw_company: '',
      sw_tr:'',
      search_container: '',
      search_text: 'Search for Address..',
      Deselect: {
        render: createElement => {
          return createElement('span', {
            on: {
              click: ()=>{
                this.$emit('deselect',this)
              }
            }
          },'❌')
        }
      },
    }
  },
    watch: {
    'sw_id'(val){
      if(this.sw_isNew){
        this.sw_isNewError = this.ipsites.filter(function (item) { return item.refid.toUpperCase() === val.toUpperCase()}).length == 1
      }
    },
    'sw_select' (payload) {
          if(!payload){
          return
        }
        if (payload.Type == 'Postcode') {      
          this.search_container = payload.Id
          this.onSearch('')

        }
       if (payload.Type == 'Address') { 
         var vm = this
         const cl = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws?Key=${vm.key}&Country=GBR&Id=${encodeURIComponent(payload.Id)}`
        fetch(cl).then(res => {        
          res.json().then(j => {
            const n = j.Items[0]
            vm.sw_address1 =`${n.BuildingName} ${n.BuildingNumber}`
            vm.sw_address2 = n.Street
            vm.sw_address3 = ''
            vm.sw_town = n.City  
            vm.sw_postcode = n.PostalCode  
            vm.sw_country = n.CountryName
            // vm.DetectChanges()
          })
        })    
      }  
     } 
  },
  computed: { 
    isUpdateOrNew(){
      return  this.sw_isNew ? 'Add' : 'Update'
    },
  },
  mounted () {},
  methods: {    
    setIpAddress(){},
    newIpSite(){
      const tr={
        refid:'',
        address1:'',
        address2:'',
        country:'',
        postcode:'',
        town:'',
        company:''
      }      
      this.sw_isNew = true     
      this.showIpDetails(tr)
    },
      getIpSiteDetails(tr){
      this.sw_isNew = false     
      this.showIpDetails(tr)
    },
    showIpDetails(tr){        
      this.activePrompt = true
      this.sw_id = tr.refid
      this.sw_address1 = tr.address1 || ''
      this.sw_address2 = tr.address2 || ''
      this.sw_address3 = tr.address3 || ''
      this.sw_country = tr.country  || ''
      this.sw_postcode =tr.postcode  || ''    
      this.sw_town  = tr.town || ''
      this.sw_company = tr.company || ''
      this.sw_tr = tr   
    },
    getIpSites(){
      var _self = this
      _self.$store.dispatch('dataList/getAllInfopointSites').then(r => {   
        debugger     
         _self.ipsites = JSON.parse(r.data.data) || []
         _self.$vs.loading.close()
      })
    },
    onSearch (search) {
      var vm = this
      const sc = vm.search_container
      search = sc === '' ? search : sc
      const cl = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws?Key=${this.key}&Country=GBR&Text=${encodeURIComponent(search)}&IsMiddleware=false&Container=${sc}&Origin=&Language=en-gb`
      fetch(cl).then(res => {        
        res.json().then(json => {
          vm.sw_options = json.Items
        })
      })      
    },
    deleteIp(){
      const payload = {
        id: -99,
        refid: this.sw_id,
        Company:  '',
        address1: '',
        address2: '',
        address3: '',
        town: '',
        country: '',
        countrySC:'',
        postCode: '',
        region:'',           
        ipaddress:''
      }        

       const _self = this
      _self.$vs.loading()
      _self.$store.dispatch('dataList/setAddressDetails', payload).then(q => {

        var t =  JSON.parse(q.data.data)        
        var _upi  = t.refid=='Deleted' ? 'success': 'error'
        var _upnn =  t.refid=='Deleted' ? '': 'Not '       
          
        _self.activePrompt = false

        _self.$swal({
          title: 'Delete Infopoint Site',
          text: `${_self.sw_id} has ${_upnn}been Deleted`,
          icon: _upi,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close'
        }).then(()=>{ 
          _self.getIpSites()  
        })
        _self.$vs.loading.close()
      })


    },
    updateAdd(){ 
      const  i = (this.sw_isNew) ? 1:0
      const payload = {
        id: i,
        refid: this.sw_id,
        Company:  this.sw_company,
        address1: this.sw_address1,
        address2: this.sw_address2,
        address3: this.sw_address3,
        town: this.sw_town,
        country: this.sw_country,
        countrySC:'GB',
        postCode: this.sw_postcode,
        region:'',           
        ipaddress:''
      }     

       const _self = this
      _self.$vs.loading()
      _self.$store.dispatch('dataList/setAddressDetails', payload).then(q => {

        var t =  JSON.parse(q.data.data)        
        var _upn = _self.sw_isNew ? 'Infopoint Added': 'Infopoint Updated'
        var _upnl = _self.sw_isNew ? 'added': 'updated'
        var _upi  = t.refid!='' ? 'success': 'error'
        var _upnn =  t.refid!='' ? '': 'Not '       
          
        _self.activePrompt = false

        _self.$swal({
          title:  _upn,
          text: `${_self.sw_company} has ${_upnn}been ${_upnl}`,
          icon: _upi,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close'
        }).then(()=>{ 
          _self.getIpSites()  
        })
        _self.$vs.loading.close()
      })
    }
  },
  created () {
    this.getIpSites() 
  }
}
</script>
<style lang="scss">
.round-border .vs-inputx{
  border: 0px!important; 
}
.vs-input--input:focus{
  border: 1px solid rgba(0, 0, 0, 0.1)!important;
  height: 38px !important;
  width: 101%;
  border-radius: 20px !important;
}

.round-border .input-span-placeholder{
  border-radius:40px!important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.round-border .vs-icon{
  padding-top: 4px;
}

.content-tr-expand{    justify-content: flex-end!important;}
.tr-expand td .tr-expand--close {background-color:inherit!important;}
.vs-con-table .empty {
     display: none!important;
}
.vs-dialog{
  max-width:none!important;
}
</style>
